import { useEffect } from 'react';

interface DocMeta {
  title: string;
  description?: string;
  keywords?: string;
}

export function useDocumentTitle({ title, description, keywords }: DocMeta) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content?: string) => {
      if (!content) return;
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    return () => {
      document.title = '午夜小电影-精选午夜主题短片及影片推荐';
    };
  }, [title, description, keywords]);
}